module.exports = __webpack_public_path__ + "static/img/ClaimRewards.043a3f74.png";